<template>
	<div>
		<div id='spec-search-title'>选择证件照规格</div>
		<div id='spec-search-main'>
			<div id='search-input-search-result-container'>
				<div id='search-input-container'>
					<input placeholder="搜索更多证件照规格" id='search-input' v-model="keyWord" @keyup.enter="searchSpec" />
					<img src="../assets/search.png" @click="searchSpec">
				</div>
				<div class="spec-container" v-if="specList.length>0">
					<div class="spec" v-for="item in specList" :key="item.spec_id" @click="chooseSpec(item)">
						<div class="spec-icon">
							<img src="../assets/spec_icon.png">
						</div>
						<div class="spec-name">{{item.name}}</div>
						<div class="spec-params">
							<span>{{item.width_mm}}mm×{{item.height_mm}}mm</span>|<span>{{item.width_px}}px×{{item.height_px}}px</span>
						</div>
					</div>
				</div>
			</div>
			<div class="spec-detail-container" v-if="JSON.stringify(chosenSpec) !== '{}'">
				<div class="spec-detail-name">{{chosenSpec.name}}</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">冲印尺寸</div>
					<div class="spec-detail-info">{{chosenSpec.width_mm}}mm × {{chosenSpec.height_mm}}mm</div>
				</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">像素大小</div>
					<div class="spec-detail-info">{{chosenSpec.width_px}}px × {{chosenSpec.height_px}}px</div>
				</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">分辨率</div>
					<div class="spec-detail-info">{{chosenSpec.ppi}}</div>
				</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">背景色</div>
					<div class="spec-detail-info">
						<div v-for="item in chosenSpec.background_color" :key="item.color_name" class="bg-dot" :style = "'background:linear-gradient(#'+item.start_color.toString(16)+',#'+item.enc_color.toString(16)+')'"></div>
					</div>
				</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">文件大小</div>
					<div class="spec-detail-info">{{chosenSpec.handledFileSize}}</div>
				</div>
				<div class="spec-detail-line">
					<div class="spec-detail-title">文件格式</div>
					<div class="spec-detail-info">{{chosenSpec.photo_format}}</div>
				</div>
				<div id="to-make-button" @click="$emit('specChosen',chosenSpec)">确认</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	specSearch
} from "../api/index.js";
import {
	handleFileSize
} from "../utils/utils.js"
export default {
	data() {
		return {
			chosenSpec:{},
			specList:[],
			keyWord:''
		}
	},
	methods:{
		searchSpec:function(){
			specSearch(this.keyWord).then(res=>{
				console.log(res)
				if(res.data.code==200){
					this.specList = res.data.result
				}
			})
		},
		chooseSpec:function(e){
			this.chosenSpec = e;
			this.chosenSpec.handledFileSize = handleFileSize(e);
		},
		
	}
}
</script>

<style scoped="scoped">
	#spec-search-title{
		font-size: 24px;
		font-weight: bold;
		color: #293B57;
		text-align: center;
	}
	#spec-search-main{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 2.8125vw;
	}
	#search-input-search-result-container{
		width:673px;
		height: 391px;
		padding-top: 75px;
		position: relative;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}
	#search-input-container{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		width: 100%;
		height: 51px;
		background: #E8F6FE;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 24px;
		padding-right: 15px;
		box-sizing: border-box;
	}
	#search-input-container>img{
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
	#search-input{
		border: none;
		outline: none;
		background-color: inherit;
		width: 100%;
	}
	.spec-container{
		overflow-y: scroll;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		height: 316px;
		padding-top: 8px;
		box-sizing: border-box;
	}
	.spec{
		width: 200px;
		height: 154px;
		background: #FFFFFF;
		box-shadow: 0px 2px 16px 0px #D3EFFE;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		margin-bottom: 8px;
	}
	.spec-icon{
		width: 65px;
		height: 65px;
		background: #E8F6FE;
		border-radius: 3px;
		padding: 9px;
		box-sizing: border-box;
	}
	.spec-icon>img{
		width: 47px;
		height: 44px;
	}
	.spec-name{
		font-size: 16px;
		color: #293B57;
		margin-top: 14px;
		text-align: center;
	}
	.spec-params{
		font-size: 14px;
		color: rgba(41, 59, 87, 0.6);
		margin-top: 12px;
	}
	.spec-detail-container{
		width: 309px;
		height: 391px;
		background: #FFFFFF;
		box-shadow: 0px 2px 16px 0px #D3EFFE;
		border-radius: 5px;
		padding: 38px 33px;
		box-sizing: border-box;
		margin-left: 41px;
	}
	.spec-detail-name{
		font-size: 24px;
		font-weight: bold;
		color: #363636;
	}
	.spec-detail-line{
		display: flex;
		align-items: center;
		margin-top: 13px;
	}
	.spec-detail-title{
		font-size: 16px;
		color: rgba(41, 59, 87, 0.7);
		width: 50%;
	}
	.spec-detail-info{
		font-size: 16px;
		color: #293B57;
		width: 50%;
	}
	.bg-dot{
		display: inline-block;
		width:10px;
		height:10px;
		margin-left: 6px;
		border-radius: 50%;
		border: 1px solid rgba(225, 225, 225, 1);
	}
	#to-make-button{
		width: 119px;
		height: 40px;
		background: #51CBFD;
		border-radius: 4px;
		font-size: 20px;
		font-weight: bold;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		margin: 54px auto 0;
	}
</style>
